import {
  FileUploadListResponse,
  FileUploadResponse,
  Inspection,
  OrderListQuery,
  OrderSearchResponse,
  UploadOrderDataResponseV2,
} from 'api/Responses/OrderResponses';
import axiosInstance from 'services/APIService';
import { MergeUploadOrderDataResponse } from '../Responses/OrderResponses';

const ENDPOINT_PATH = `/v1/orders`;
const ENDPOINT_PATH_V2 = `/v2/orders`;

/*
 * Lists all orders in receiving
 */
export const getReceivingList = async (query: OrderListQuery): Promise<OrderSearchResponse> => {
  const response = await axiosInstance.get<OrderSearchResponse>(`${ENDPOINT_PATH}/receiving/list`, {
    params: query,
  });
  return response.data;
};

export const uploadOrderData = async (
  onUploadProgress: (progressEvent: ProgressEvent) => void,
  file: File,
): Promise<FileUploadResponse> => {
  const data = new FormData();
  data.append('file', file, file.name);

  const response = await axiosInstance.post<FileUploadResponse>(`${ENDPOINT_PATH}/receiving/file-upload`, data, {
    onUploadProgress: onUploadProgress,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const getUploadOrderData = async (uploadId: string): Promise<FileUploadListResponse> => {
  const response = await axiosInstance.get<FileUploadListResponse>(
    `${ENDPOINT_PATH}/receiving/file-upload/${uploadId}`,
  );
  return response.data;
};

export const mergeUploadOrderData = async (
  uploadId: string,
  duplicates: Pick<Inspection, 'gs_one_barcode' | 'ignore'>[],
): Promise<MergeUploadOrderDataResponse> => {
  const response = await axiosInstance.put<MergeUploadOrderDataResponse>(
    `${ENDPOINT_PATH}/receiving/file-upload/${uploadId}`,
    { merge: true, duplicates: duplicates },
  );

  return response.data;
};

export const cancelUploadOrderData = async (uploadId: string): Promise<MergeUploadOrderDataResponse> => {
  const response = await axiosInstance.put<MergeUploadOrderDataResponse>(
    `${ENDPOINT_PATH}/receiving/file-upload/${uploadId}`,
    { merge: false },
  );

  return response.data;
};

export const getFileUploadHistoryList = async (): Promise<FileUploadListResponse[]> => {
  const response = await axiosInstance.get<FileUploadListResponse[]>(`${ENDPOINT_PATH}/receiving/file-upload`);
  return response.data;
};

/*
 * Using V2 endpoints
 */

export const getReceivingListV2 = async (query: OrderListQuery): Promise<OrderSearchResponse> => {
  const response = await axiosInstance.get<OrderSearchResponse>(`${ENDPOINT_PATH_V2}/receiving/list`, {
    params: query,
  });
  return response.data;
};

export const getFileUploadHistoryListV2 = async (): Promise<FileUploadListResponse[]> => {
  const response = await axiosInstance.get<FileUploadListResponse[]>(`${ENDPOINT_PATH_V2}/receiving/file-upload`);
  return response.data;
};

export const uploadOrderDataV2 = async (upload_id: string, gs_location: string): Promise<UploadOrderDataResponseV2> => {
  const response = await axiosInstance.post<UploadOrderDataResponseV2>(`${ENDPOINT_PATH_V2}/receiving/file-upload`, {
    upload_id,
    gs_location,
  });

  return response.data;
};

export const mergeUploadOrderDataV2 = async (
  uploadId: string,
  duplicates: Pick<Inspection, 'gs_one_barcode' | 'ignore'>[],
): Promise<UploadOrderDataResponseV2> => {
  const response = await axiosInstance.put<UploadOrderDataResponseV2>(
    `${ENDPOINT_PATH_V2}/receiving/file-upload/${uploadId}`,
    { merge: true, duplicates: duplicates },
  );

  return response.data;
};

// Get status of file upload
export const getFileUploadStatusV2 = async (uploadId: string): Promise<UploadOrderDataResponseV2> => {
  const response = await axiosInstance.get<UploadOrderDataResponseV2>(
    `${ENDPOINT_PATH_V2}/receiving/file-upload/${uploadId}/status`,
  );
  return response.data;
};

export const cancelUploadOrderDataV2 = async (uploadId: string): Promise<MergeUploadOrderDataResponse> => {
  const response = await axiosInstance.put<MergeUploadOrderDataResponse>(
    `${ENDPOINT_PATH_V2}/receiving/file-upload/${uploadId}`,
    { merge: false },
  );

  return response.data;
};
